// Dont load in test env because API makers error-logger already load source maps and loading twice fucks it up
const peakFlowErrors = globalThis.peakFlowErrors || globalThis.peakflowErrors

if (peakFlowErrors && globalThis.RAILS_ENV != "test") {
  peakFlowErrors.loadSourceMapForScriptTags((scriptTag) => {
    const src = scriptTag.getAttribute("src")
    const type = scriptTag.getAttribute("type")

    if (src && src.includes("/packs/") && (type == "text/javascript" || !type)) {
      const url = peakFlowErrors.loadUrl(src)
      const originalUrl = `${url.origin}${url.pathname}`

      return originalUrl
    }

    return false
  })
}
